import { BaseEditViewStore, BaasicDropdownStore } from 'core/stores';
import { FacilityOrderNewFlowUSIntakeFindAndReplaceModalForm } from 'application/facility-order-new-flow-us-intake/forms';
import { ProductService } from 'application/product/services';
import { action, observable } from "mobx";
import { FacilityOrderTemplateService, FacilityOrderTemplateItemService } from "application/facility-order/services";
import _ from 'lodash';
import { ModalParams } from "core/models";
import { LookupService } from 'common/services';

class FacilityOrderNewFlowUSIntakeFindAndReplaceModalStore extends BaseEditViewStore {
    @observable accessor disabled = true;
    @observable accessor currentProducts;
    @observable accessor newProducts;
    @observable accessor isNewProductEmpty = true;
    @observable accessor isLoading = false;
    constructor(rootStore, componentProps) {
        const facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);
        const facilityOrderTemplateItemService = new FacilityOrderTemplateItemService(rootStore.application.baasic.apiClient);
        const productService = new ProductService(rootStore.application.baasic.apiClient);
        const lookupService = new LookupService(rootStore.application.baasic.apiClient);
        const facilityOrderId = componentProps.modalParams.data.facilityOrderId;

        super(rootStore, {
            name: 'facility-order-new-flow-us-intake-find-and-replace-modal',
            Form: FacilityOrderNewFlowUSIntakeFindAndReplaceModalForm,
            id: facilityOrderId,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                    get: async () => {
                        const response = await lookupService.getLookups("UnitOfMeasure");
                        this.unitOfMeasures = response.unitOfMeasure;
                    },
                    update: async (resource) => {
                        await facilityOrderTemplateItemService.findAndReplaceItem(resource);
                    },
                    delete: async (resource) => {
                        await facilityOrderTemplateItemService.findAndDeleteItem(resource);
                    }
                }
            },
            FormClass: FacilityOrderNewFlowUSIntakeFindAndReplaceModalForm
        });

        this.facilityOrderNewFlowUSIntakeFindAndDeleteConfirmationModal = new ModalParams({});

        this.currentProductStore = new BaasicDropdownStore({
            filterable: true,
            returnObject: true
        }, {
            fetchFunc: async (term) => {
                const lookups = await lookupService.getLookups("UnitOfMeasure");
                const unitOfMeasureId = lookups.unitOfMeasure.find(x => x.abrv == 'CA').id;

                const response = (await facilityOrderTemplateService.findReplacementItems({ facilityOrderId: facilityOrderId, searchQuery: term, unitOfMeasureIdToExclude: unitOfMeasureId })).data.item;
                const products = _.flatMap(response, entry => entry.facilityOrderTemplateItems.map(item => item.product));
                const distinctProducts = _.uniqBy(products, 'id');
                const sortedProducts = _.sortBy(distinctProducts, 'itemId');
                return _.map(sortedProducts, item => {
                    return {
                        ...item,
                        name: item.itemId + ' ' + item.description,
                    };
                });
            },
            onChange: async (product) => {
                this.disabled = true;
                await this.currentProductChange(product);
            }
        });

        this.newProductStore = new BaasicDropdownStore({
            filterable: true,
            initFetch: false,
            returnObject: true
        }, {
            fetchFunc: async (term) => {
                const response = await productService.find({
                    sort: "itemId|asc",
                    searchQuery: term,
                    rpp: 50,
                    isActive: true,
                    itemCategoryId: this.currentProductStore.value.subCategory.itemCategoryId,
                    itemTypeId: this.currentProductStore.value.itemTypeId,
                    unitOfMeasureIdToExclude: this.unitOfMeasures.find(x => x.abrv == 'CA').id
                });
                var items = response.data.item.filter(i => i.id != this.currentProductStore.value.id && (!this.currentProductStore.value.itemTypeId || (i.calsPerMl || 0) == (this.currentProductStore.value.calsPerMl || 0)));
                return _.map(items, item => {
                    return {
                        ...item,
                        name: item.itemId + ' ' + item.description,
                    };
                });
            },
            onChange: async (product) => {
                await this.newProductChange(product);
            }
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.facilityOrderTemplateService = facilityOrderTemplateService;
        this.facilityOrderTemplateItemService = facilityOrderTemplateItemService;
        this.facilityOrderId = facilityOrderId;
        this.fetchData = this.modalParams.data.fetchData
    }

    @action.bound
    async currentProductChange(product) {
        if (!product) {
            this.disabled = true;
            return;
        }

        this.isNewProductEmpty = true;
        await this.getCurretProducts(product.id);
        this.newProducts = null;
        this.newProductStore.setValue(null);
        this.form.$("newProductId").value = "";
        await this.newProductStore.filterAsync();
        this.disabled = false;
    }

    @action.bound
    async getCurretProducts(productId) {
        const unitOfMeasureId = this.unitOfMeasures.find(x => x.abrv == 'CA').id;
        var response = (await this.facilityOrderTemplateService.findReplacementItems({ facilityOrderId: this.facilityOrderId, productId: productId, unitOfMeasureIdToExclude: unitOfMeasureId })).data.item;
        this.currentProducts = _.flatMap(response, entry => entry.facilityOrderTemplateItems.map(item => ({ ...item, facilityOrderTemplateId: entry.id, inactiveReason: entry.inactiveReason == "DoNotSupply" ? "Do Not Supply" : entry.inactiveReason, patientName: `${entry.patient.lastName}, ${entry.patient.firstName}`, isLastItem: entry.isLastItem, subCategoryName: entry.subCategory.name})));
    }

    @action.bound
    async newProductChange(product) {
        if (!product) {
            this.isNewProductEmpty = true;
            this.newProducts = undefined;
            return;
        }
        this.isNewProductEmpty = false;
        this.disabled = true;
        let newProducts = [...this.currentProducts];
        if (newProducts && newProducts.length > 0 && (this.currentProductStore.value.mlsPerContainer || 0) != (product.mlsPerContainer || 0)) {
            var response = (await this.facilityOrderTemplateItemService.calculateReplacementItemsQuantity(newProducts.map(item => ({ ...item, productId: product.id })))).data;
            newProducts = _.map(newProducts, (i => {
                const newItem = response.find(x => x.id == i.id);
                return newItem ? { ...i, templateQuantity: newItem.templateQuantity, orderQuantity: newItem.orderQuantity } : i;
            }));

        }
        this.newProducts = newProducts;
        this.disabled = false;
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;
        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }
            await this.actions.update({ ...resource, facilityOrderId: this.facilityOrderId });
            await this.fetchData();
            this.form.setFieldsDisabled(false);
            this.modalParams.close();
            await setTimeout(() => this.notifySuccessUpdate(this.name), 10);
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error(err.data ? err.data : "Error occurred while trying to replace product.");
        }
    }

    @action.bound
    async deleteFacilityOrderTemplateItems() {
        var templateForDelete = this.currentProducts.filter(x => x.isLastItem);
        if (templateForDelete && templateForDelete.length > 0) {
            const distinctList = _.uniqBy(templateForDelete, "facilityOrderTemplateId");
            this.facilityOrderNewFlowUSIntakeFindAndDeleteConfirmationModal.open({
                deleteItems: () => this.deleteItems(),
                facilityOrderTemplates: distinctList
            });
        }
        else {
            await this.deleteItems();
        }
    }

    @action.bound
    async deleteItems() {
        this.form.setFieldsDisabled(true);
        this.isLoading = true;
        try {
            await this.actions.delete({facilityOrderId: this.facilityOrderId, currentProductId: this.form.$("currentProductId").value });
            await this.fetchData();
            this.isLoading = false;
            this.form.setFieldsDisabled(false);
            this.modalParams.close();
            await setTimeout(() => this.notifySuccessUpdate(this.name), 10);
        }
        catch (err) {
            this.isLoading = false;
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error((err.data && !err.data.message)? err.data : "Error occurred while trying to delete facility order template items.");
        }
    }
}

export default FacilityOrderNewFlowUSIntakeFindAndReplaceModalStore;
